﻿//==========================================================================================================
// Copyright (C) Nore Technology AB. All Rights Reserved.
//==========================================================================================================

//-------------------------------------------------------------------------------------
// Imports
//-------------------------------------------------------------------------------------

//-------------------------------------------------------------------------------------
// State
//-------------------------------------------------------------------------------------

type UpdateFormCredentials = {
    type: "updateFormCredentials";
    username: string;
};
type UpdateError = { type: "setError"; errorMessage: string };
type SetLoading = { type: "setLoading" };

export type ResetPageViewAction =
    | UpdateFormCredentials
    | UpdateError
    | SetLoading;

interface ResetPageState {
    username: string;
    loading: boolean;
    errorMessage: string;
}

export function reducer<T>(
    state: ResetPageState,
    action: ResetPageViewAction
): ResetPageState {
    switch (action.type) {
        case "updateFormCredentials": {
            return { ...state, username: action.username, errorMessage: null };
        }
        case "setError": {
            return { ...state, errorMessage: action.errorMessage };
        }
        case "setLoading": {
            return { ...state, errorMessage: null, loading: true };
        }
    }
}
